import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { Classes } from '@blueprintjs/core';
import { withClassNames } from '../../utils/with-classnames.js';
import { DropdownMenuSubTrigger, DropdownMenuItem } from './dropdown-menu-item.js';
import { DropdownMenuRadioItem, DropdownMenuCheckboxItem } from './dropdown-menu-input-item.js';
import { usePopperJsPositioning } from '../popover/utils.js';
import React__default, { forwardRef, Children } from 'react';
import cx from 'classnames';
import { isIE11 } from '../../utils/isIE11.js';

var _excluded = ["children"],
    _excluded2 = ["content", "target", "className", "defaultOpen", "onOpenChange", "open", "placement", "tooltip", "contentWrapperProps", "maxWidth"],
    _excluded3 = ["children", "placement"];
var Divider = withClassNames([Classes.MENU_DIVIDER], RadixDropdownMenu.Separator); // Divider aliases

var Separator = Divider;
var Seperator = Divider;
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Label, _extends({
    asChild: true
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("li", {
    className: Classes.MENU_HEADER
  }, /*#__PURE__*/React__default.createElement("div", {
    className: Classes.HEADING
  }, children)));
}); // Heading aliases

var Label = Heading;

var StyledDropdownMenuRadioGroup = /*#__PURE__*/_styled(RadixDropdownMenu.DropdownMenuRadioGroup, {
  target: "ek9pqs20"
})({
  name: "1bia64w",
  styles: ".bp3-control{margin-top:0 !important;}"
});

var menuWidths = {
  large: "360px",
  medium: "260px",
  small: "180px"
};
var Menu = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var content = _ref2.content,
      target = _ref2.target,
      className = _ref2.className,
      defaultOpen = _ref2.defaultOpen,
      onOpenChange = _ref2.onOpenChange,
      open = _ref2.open,
      placement = _ref2.placement;
      _ref2.tooltip;
      var contentWrapperProps = _ref2.contentWrapperProps,
      _ref2$maxWidth = _ref2.maxWidth,
      maxWidth = _ref2$maxWidth === void 0 ? "medium" : _ref2$maxWidth,
      otherTriggerProps = _objectWithoutProperties(_ref2, _excluded2);

  var _usePopperJsPositioni = usePopperJsPositioning({
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    open: open,
    placement: placement,
    className: cx(className, "vds-dropdown-menu", "vds-popover"),
    arrowType: "none",
    content: /*#__PURE__*/React__default.createElement("ul", {
      className: cx(Classes.MENU),
      style: {
        maxWidth: menuWidths[maxWidth]
      }
    }, content),
    contentWrapperProps: contentWrapperProps,
    triggerRef: ref
  }),
      rootProps = _usePopperJsPositioni.rootProps,
      triggerProps = _usePopperJsPositioni.triggerProps,
      contentProps = _usePopperJsPositioni.contentProps;

  Children.only(target);
  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Root, rootProps, /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Trigger, _extends({}, otherTriggerProps, triggerProps), target), /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Content, _extends({
    loop: true
  }, contentProps)));
});
var SubMenu = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      placement = _ref3.placement,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var _usePopperJsPositioni2 = usePopperJsPositioning({
    className: cx("vds-dropdown-menu", "vds-popover"),
    arrowType: "none",
    content: /*#__PURE__*/React__default.createElement("ul", {
      className: cx(Classes.MENU),
      style: {
        maxWidth: menuWidths.small
      }
    }, children),
    triggerRef: ref,
    portaled: false,
    placement: placement
  }),
      rootProps = _usePopperJsPositioni2.rootProps,
      triggerProps = _usePopperJsPositioni2.triggerProps,
      contentProps = _usePopperJsPositioni2.contentProps;

  if (isIE11()) {
    var _props$text;

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Heading, {
      ref: ref
    }, (_props$text = props.text) !== null && _props$text !== void 0 ? _props$text : null), children);
  }

  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Root, rootProps, /*#__PURE__*/React__default.createElement(DropdownMenuSubTrigger, _extends({}, props, {
    ref: triggerProps.ref
  })), /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Content, contentProps));
});
var DropdownMenu = {
  Menu: Menu,
  Item: DropdownMenuItem,
  RadioGroup: StyledDropdownMenuRadioGroup,
  RadioItem: DropdownMenuRadioItem,
  CheckboxItem: DropdownMenuCheckboxItem,
  Divider: Divider,
  Separator: Separator,
  Seperator: Seperator,
  SubMenu: SubMenu,
  Heading: Heading,
  Label: Label
};

export { DropdownMenu };
//# sourceMappingURL=dropdown-menu.js.map
